import React, { useEffect, useRef } from "react";
import "./cropper.css";

export const Cropper = ({ src, getBlob, closeCropper }) => {
    const cropper = useRef(null);
    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://cdnjs.cloudflare.com/ajax/libs/cropperjs/2.0.0-alpha.2/cropper.js";
        script.async = true;
        script.onload = () => initializeCropper(cropper);
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const initializeCropper = (cropperRef) => {
        const image = document.getElementById("cropper");
        cropperRef.current = new window.Cropper(image, {
            viewMode: 1,
            aspectRatio: 14 / 16,
            cropBoxResizable: false,
            background: false,
            modal: false,
        });
    };

    const getBase64 = (event, cropperRef) => {
        event.preventDefault();
        return getBlob(cropperRef.current.getCroppedCanvas().toDataURL());
    };

    return (
        src && (
            <>
                <img id="cropper" src={src} alt="preview" />
                <div className="events">
                    <a
                        onClick={closeCropper}
                        className="cancel"
                        href="javascript(void);"
                    >
                        <i className="icon-cancel"></i>
                    </a>
                    <a
                        className="save"
                        href="javascript(void);"
                        onClick={(event) => getBase64(event, cropper)}
                    >
                        <i className="icon-check"></i>
                    </a>
                </div>
            </>
        )
    );
};
